import { StatusState } from '../store';

export const isFetching = (state: StatusState) => state.status === null;
